import MyLoading from './src/MyLoading.js'
export default MyLoading



// WEBPACK FOOTER //
// ./src/components/MyLoading/index.js